import React, { Component } from "react";
import Modal from "react-bootstrap/lib/Modal";
import { isEmpty } from "lodash";
import R from "ramda";

import {isSunday} from '../utils/DateHelpers';


import {
  SLBDatePicker,
  SLBSelect,
  SLBTxtBox,
  SLBTextarea
} from "../utils/Forms";

export default class NoticeModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      notice: {}
    };
    this.handleEditorChanged = this.handleEditorChanged.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setNotice(nextProps.currentNotice);
  }
  setNotice(data = {}) {
    const notice = {
      title: data.title || "",
      start_week_date: data.start_week_date || "",
      content: data.content || "",
      notice_category_id: data.notice_category_id || "",
      id: data.id || 0
    };

    this.setState({ notice });
  }

  handleDateChange(newVal) {
    const updatedNotice = { ...this.state.notice, start_week_date: newVal };
    this.setState({ ...this.state, notice: updatedNotice });
  }

  handleEditorChanged(content) {
    let updatedNotice = { ...this.state.notice, content: content };
    this.setState({ ...this.state, notice: updatedNotice });
  }

  handleChange(e) {
    const target = e.target;
    const name = target.name;
    const value = target.value;

    let newNotice = { ...this.state.notice, [name]: value };
    this.setState({ ...this.state, notice: newNotice });
  }

  isNoticeValid(notice = {}) {
    let errors = {};

    const {title,content, start_week_date, notice_category_id} = notice;
    if (isEmpty(title)) {
      errors["title"] = "Title is required!";
    }

    if (isEmpty(content)) {
      errors["content"] = "Content is required!";
    }

    if (isEmpty(start_week_date)) {
      errors["start_week_date"] = "Start week date is required!";
    }

    if (!notice_category_id) {
      errors["notice_category_id"] = "Notice category is required! Set to `General if unsure.`";
    }

    this.setState({ errors });
    return isEmpty(errors);
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.isNoticeValid(this.state.notice)) {
      this.props.saveNotice(this.state.notice);
    }
  }

  render() {
    let {
      title,
      start_week_date,
      notice_category_id,
      content,
      id
    } = this.state.notice;
    let { errors } = this.state;
    let { noticeCategories } = this.props;
    let buttonText = id > 0 ? "Update" : "Create";

    const categoryNames = [""].concat(R.map(R.prop("name"))(noticeCategories));

    const categoryValues = [""].concat(R.map(R.prop("id"))(noticeCategories));

    return (
      <Modal show={this.props.showModal} onHide={() => this.props.hideModal()}>
        <Modal.Header closeButton>
          <Modal.Title>Event Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="">
            <form onSubmit={this.handleSubmit}>
              <div className="clearfix">
                <div className="row">
                  <SLBTxtBox
                    label="Title"
                    name="title"
                    value={title}
                    context={this}
                    attrs={{ errors, klass: "col-md-12" }}
                    />
                </div>
                <div className="row">
                  <SLBDatePicker
                    label="Start Week Date"
                    name="start_week_date"
                    value={start_week_date}
                    handleChange={this.handleDateChange}
                    attrs={{ errors,filterDate: isSunday}}
                    />

                  <SLBSelect
                    label="Category"
                    name="notice_category_id"
                    value={notice_category_id}
                    context={this}
                    options={categoryNames}
                    values={categoryValues}
                    attrs={{ errors,  klass: "col-md-9"}}
                    />
                </div>

                <div className="row">
                  <SLBTextarea
                    label="Content"
                    name="content"
                    value={content}
                    context={this}
                    handleEditorChanged={this.handleEditorChanged}
                    attrs={{ errors, klass: "col-md-12" }}
                  />
                </div>
                <div className="col-md-12 edit-buttons-pane">
                  <input
                    className="btn btn-success pull-right"
                    type="submit"
                    value={buttonText}
                  />
                  <a
                    className="btn btn-default pull-right"
                    style={{ marginRight: 10 }}
                    onClick={() => this.props.hideModal()}
                  >
                    Cancel
                  </a>
                </div>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NoticeModal.js